<template>
	<div class="p-20">
		<h1 class="mt-0">{{ $t('CreditNoteDetail.title') }}</h1>

		<el-row :gutter="5">
			<el-col :span="17">
				<el-card class="mb-5">
					<document-detail v-if="creditNote" :document="creditNote" :document-type="'credit_note'"></document-detail>
				</el-card>
				<el-card v-if="creditNote && creditNote.custom_fields" class="mb-5">
					<h4 class="mb-20">{{ $t('shared.custom_fields') }}</h4>
					<custom-fields-list
						v-if="userInterfaceDetails && userInterfaceDetails.custom_field_definitions"
						:custom-field-definitions="userInterfaceDetails.custom_field_definitions"
						:custom-fields="creditNote.custom_fields"
					/>
					<el-button
						size="mini"
						class="mb-10"
						@click="showCustomFields = !showCustomFields"
					>
						<span v-if="showCustomFields">
							{{ $t('shared.hide_custom_fields') }}
						</span>
						<span v-else>
							{{ $t('shared.show_custom_fields') }}
						</span>
					</el-button>
					<json-editor v-if="showCustomFields" :value="creditNote.custom_fields"></json-editor>
				</el-card>
				<el-card class="mb-5">
					<template v-for="file in files">
						<el-button :key="`${file.name}-btn`" type="primary" size="mini" @click="onDownload(file)"> Download {{ $tc('creditnote', 1).toLowerCase() }} </el-button>
						<pdf v-if="isUriAttachment(file) && !file.uri.startsWith('s3')" :key="file.name" :src="file.uri"> </pdf>
					</template>
				</el-card>
			</el-col>
			<el-col :span="7">

			</el-col>
		</el-row>
	</div>
</template>

<script>
import DocumentDetail from '@/components/DocumentDetail.vue';
import JsonEditor from '@/components/JsonEditor';
import { mapGetters } from 'vuex';
import pdf from 'vue-pdf';
import { attachmentDownload } from '@/api/attachment';
import { isUriAttachment } from '@/schema/attachment';
import CustomFieldsList from '@/components/_CustomFields/CustomFieldsList.vue';
import { ViewsCreditNotes_UserInterfaceDetails, ViewsCreditNotes_Detail } from '@/generated/graphql';

export default {
	apollo: {
		creditNote: {
			query: ViewsCreditNotes_Detail,
			variables() {
				return {
					credit_note: this.$route.params.reference
				};
			},
			update: data => data.creditNote[0]
		},
		userInterfaceDetails: {
			query: ViewsCreditNotes_UserInterfaceDetails,
			variables() {
				return {
					participant: this.selectedParticipantStore
				};
			},
			update: data => data.userInterfaceDetails[0],
			skip() {
				return !this.creditNote;
			}
		}
	},
	components: {
		CustomFieldsList,
		DocumentDetail,
		JsonEditor,
		pdf
	},
	data() {
		return {
			files: [],
			creditNote: undefined,
			showCustomFields: false
		};
	},
	computed: {
		...mapGetters(['env', 'selectedParticipantStore'])
	},
	watch: {
		creditNote: {
			handler(val) {
				if (val) {
					for (const file of val.file_references) {
						this.files.push(file);
					}
				}
			},
			immediate: true
		}
	},
	methods: {
		async onDownload(val) {
			attachmentDownload(this.selectedParticipantStore, val);
		},
		isUriAttachment(val) {
			return isUriAttachment(this.selectedParticipantStore, val);
		}
	}
};
</script>

<style lang="scss"></style>
